import { OnboardingUserWizard } from '@/features/onboarding/components/OnboardingUserWizard';
import styles from '@/features/onboarding/components/Onboarding.module.css';


export function OnboardingUserPage() {
    return (
        <div className={styles.pageContainer}>
            <OnboardingUserWizard />
        </div>
    );
}
